import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../assets/css/InnerHeader.css";

const InnerHeader = () => {

  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (

    <nav className="inner-hero-nav">

      <Link to="/" className="inner-logo">
        Indrajeet Patil
      </Link>

      {/* HAMBURGER */}

      <div
        className={`inner-hamburger ${menuOpen ? "active" : ""}`}
        onClick={toggleMenu}
      >
        <span></span>
        <span></span>
        <span></span>
      </div>

      {/* NAV LINKS */}

      <ul className={`inner-nav-links ${menuOpen ? "open" : ""}`}>

        <li onClick={closeMenu}>
          <Link to="/">Home</Link>
        </li>

        <li onClick={closeMenu}>
          <Link to="/about">About</Link>
        </li>

        <li onClick={closeMenu}>
          <Link to="/publications">Publications</Link>
        </li>

        <li onClick={closeMenu}>
          <Link to="/blog">Blog</Link>
        </li>

        <li onClick={closeMenu}>
          <Link to="/contact">Contact</Link>
        </li>

      </ul>

    </nav>

  );
};

export default InnerHeader;